import React from 'react';
import { motion } from 'framer-motion';
import { SEO } from '../../components/SEO';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { FadeIn } from '../../components/FadeIn';
import { AnimatedText } from '../../components/AnimatedText';
import { Solutions } from '../../components/Solutions';
import { HowItWorks } from '../../components/HowItWorks';
import { Impact } from '../../components/Impact';

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const StrategicPlanning = () => {
  return (
    <div className="space-y-16">
      <SEO
        title="Strategic Growth Planning | ProfitIQ.AI"
        description="Develop and execute data-backed strategies for sustainable business growth with AI-powered insights and expert guidance."
      />
      
      <Breadcrumbs
        items={[
          { label: 'Products', href: '/products' },
          { label: 'Strategic Growth Planning' }
        ]}
      />

      <FadeIn>
        <AnimatedText
          text="AI-Powered Strategic Planning"
          el="h1"
          className="text-4xl font-bold mb-4 bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text text-center"
        />
        <p className="text-gray-400 text-lg mb-8 text-center max-w-3xl mx-auto">
          Transform your business strategy with AI-driven insights, competitive analysis, and expert guidance for sustainable growth.
        </p>
      </FadeIn>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ...springConfig }}
      >
        <Solutions />
        <HowItWorks />
        <Impact />
      </motion.div>
    </div>
  );
};